import { getHttpClient } from '@eo/shared';

// Thin wrapper. Use this everywhere instead of `getHttpClient('api')` directly:
// it gives the identifier a name in the codebase and makes it trivial to
// rename, switch, or scope clients per environment if that ever lands.
const getApiHttpClient = () => getHttpClient('api');

export default getApiHttpClient;
